export const ADMIN_ID = '5ef44b02c87d4022e93fbe33';

export const trainerIds = ['8d8ade1c-77a8-40f1-8e99-34859b55c689']